import { apiClient } from '@app/lib'
import { useMutation } from '@tanstack/react-query'

export const useChangePassword = () =>
  useMutation({
    mutationKey: ['changePassword'],
    mutationFn: async (password: string) => {
      const { data } = await apiClient.post('/api/password', { password })

      return data
    }
  })
